/*
 * AWO Find — shared suggest behaviour.
 * Initialises any [data-awofind] root: field + dropdown panel, live /suggest
 * fetch with offline fallback, skeleton, product grid, instant answers, nav
 * handoff and recent searches. Used by the homepage hero section and (soon)
 * the header search modal — both render the same markup + data island.
 */
(function () {
  'use strict';

  // ---- icons (panel rows) -----------------------------------------------
  var SPARK = '<svg width="17" height="17" viewBox="0 0 24 24" fill="currentColor"><path d="M12 2.5 10 9.5 3 12l7 2.5L12 21.5l2-7L21 12l-7-2.5z"/></svg>';
  var IC = {
    clock: '<span class="awofind__ic"><svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><circle cx="12" cy="12" r="8.5"/><path d="M12 7.5V12l3 2" stroke-linecap="round"/></svg></span>',
    glass: '<span class="awofind__ic"><svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"><circle cx="11" cy="11" r="7"/><path d="m20.5 20.5-3.6-3.6"/></svg></span>',
    spark: '<span class="awofind__ic">' + SPARK + '</span>'
  };
  var TR_ARROW = '<span class="awofind__trarrow"><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round"><path d="M5 12h13M13 6l6 6-6 6"/></svg></span>';
  var TR_UPLEFT = '<span class="awofind__trarrow"><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round"><path d="M7 17 17 7M8 7h9v9"/></svg></span>';
  var PROD_ICON = '<svg width="30" height="30" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.3"><rect x="7" y="2.5" width="10" height="19" rx="1.6"/><path d="M7 10h10M10 5.5v2M10 12.5v2.5"/></svg>';

  var RECENT_KEY = 'awo_recent_searches';
  var RECENT_MAX = 5;

  function esc(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;')
      .replace(/'/g, '&#39;').replace(/"/g, '&quot;');
  }
  function attr(s) { return esc(s); }

  function getRecent() {
    try { return JSON.parse(localStorage.getItem(RECENT_KEY)) || []; }
    catch (e) { return []; }
  }
  function pushRecent(q) {
    try {
      var list = getRecent().filter(function (r) { return r.toLowerCase() !== q.toLowerCase(); });
      list.unshift(q);
      localStorage.setItem(RECENT_KEY, JSON.stringify(list.slice(0, RECENT_MAX)));
    } catch (e) {}
  }

  function init(root) {
    if (!root || root.dataset.awofindReady) return;
    root.dataset.awofindReady = '1';

    var dataEl = root.querySelector('[data-awofind-data]');
    var DATA = {};
    try { DATA = JSON.parse(dataEl.textContent); } catch (e) { DATA = {}; }
    DATA.popular = DATA.popular || [];
    DATA.ask = DATA.ask || [];
    DATA.completions = (DATA.completions || []).map(function (t) { return String(t).trim(); }).filter(Boolean);
    var API = (DATA.apiBase || '').trim().replace(/\/+$/, ''); // e.g. https://applianceworldsearch.up.railway.app/search-api

    // ----- analytics -----------------------------------------------------
    // Report card clicks to {API}/click (suggest views are logged server-side
    // from /suggest). currentQuery attributes the click. Fire-and-forget.
    var currentQuery = '';
    function sendClick(detail) {
      if (!API) return;
      var body = JSON.stringify(detail);
      try { if (navigator.sendBeacon && navigator.sendBeacon(API + '/click', body)) return; } catch (e) {}
      try { fetch(API + '/click', { method: 'POST', body: body, keepalive: true }).catch(function () {}); } catch (e) {}
    }

    var field = root.querySelector('[data-awofind-field]');
    var input = root.querySelector('[data-awofind-input]');
    var panel = root.querySelector('[data-awofind-panel]');
    var scrim = root.querySelector('[data-awofind-scrim]');
    var clearB = root.querySelector('[data-awofind-clear]');
    var sendB = root.querySelector('[data-awofind-send]');
    var micB = root.querySelector('[data-awofind-mic]');
    var focusB = root.querySelector('[data-awofind-focus]');
    // Date-gated offer cards rendered server-side by the host (hero section only)
    var offersTpl = root.querySelector('[data-awofind-offers]');
    var OFFERS_HTML = offersTpl ? offersTpl.innerHTML.trim() : '';

    // ----- card / row builders -------------------------------------------
    function card(p, idx) {
      var media = p.image
        ? '<img src="' + attr(p.image) + '" alt="' + attr(p.title) + '" loading="lazy">'
        : PROD_ICON;

      var priceHtml = p.compare
        ? '<span class="awofind__pcard-now">' + esc(p.price) + '</span><span class="awofind__pcard-was">' + esc(p.compare) + '</span>'
        : '<span class="awofind__pcard-now">' + esc(p.price) + '</span>';

      var signals = '';
      if (p.frostFree) signals += '<span class="awofind__pcard-tag">Frost free</span>';

      // In stock → also available for collection. Subtle tick, like the trust signals.
      var TICK = '<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6 9 17l-5-5"/></svg>';
      var stock = p.inStock
        ? '<span class="awofind__pcard-stock">' + TICK + 'In stock &middot; delivery or collection</span>'
        : '';

      var deal = (p.discount && p.discount.label)
        ? '<div class="awofind__pcard-deal"><iconify-icon icon="solar:sale-bold" inline></iconify-icon><span>' + esc(p.discount.label) + '</span></div>'
        : '';

      var href = p.url || (DATA.searchAction + '?q=' + encodeURIComponent(p.title));
      return '<a class="awofind__pcard" href="' + attr(href) + '" data-awofind-pcard data-id="' + attr(p.id == null ? '' : p.id) + '" data-handle="' + attr(p.handle || '') + '" data-pos="' + (idx == null ? '' : idx) + '">' +
        '<div class="awofind__pcard-img">' + media + '</div>' +
        '<div class="awofind__pcard-meta">' +
          '<div class="awofind__pcard-nm">' + esc(p.title) + '</div>' +
          (signals ? '<div class="awofind__pcard-signals">' + signals + '</div>' : '') +
          '<div class="awofind__pcard-pc">' + priceHtml + '</div>' +
          deal +
          stock +
        '</div></a>';
    }

    // product card grid (3-wide desktop, 2-wide mobile) — vertical scroll within the panel
    function cardGrid(products) {
      return '<div class="awofind__cardgrid">' + products.map(function (p, i) { return card(p, i); }).join('') + '</div>';
    }

    // shimmer skeleton shown while suggestions load — reserves the grid so nothing jumps
    function skeletonCard() {
      return '<div class="awofind__pcard awofind__pcard--skel">' +
        '<div class="awofind__pcard-img awofind__skel-img"></div>' +
        '<div class="awofind__pcard-meta">' +
          '<div class="awofind__skel-line is-1"></div>' +
          '<div class="awofind__skel-line is-2"></div>' +
          '<div class="awofind__skel-line is-price"></div>' +
        '</div></div>';
    }
    function skeletonSection(n) {
      var cards = '';
      for (var k = 0; k < (n || 3); k++) cards += skeletonCard();
      return '<div class="awofind__sec" data-skeleton><div class="awofind__sec-label">Products</div>' +
        '<div class="awofind__cardgrid">' + cards + '</div></div>';
    }

    // ----- instant answers (contact / hours / showroom / delivery / finance / returns) -----
    var ANSWER_ICON = {
      contact: 'solar:phone-calling-rounded-bold',
      hours: 'solar:clock-circle-bold',
      showroom: 'solar:streets-map-point-bold',
      delivery: 'solar:delivery-bold',
      finance: 'solar:wallet-money-bold',
      returns: 'solar:refresh-circle-bold'
    };
    function telHref(p) { return 'tel:' + String(p || '').replace(/\s+/g, ''); }
    function hoursHtml(hours) {
      if (!hours || !hours.length) return '';
      return '<div class="awofind__answer-hours">' + hours.map(function (h) {
        return '<div class="awofind__answer-hrow"><span>' + esc(h.days) + '</span><span>' + esc(h.time) + '</span></div>';
      }).join('') + '</div>';
    }
    function answerBlock(a) {
      if (!a) return '';
      var icon = ANSWER_ICON[a.type] || 'solar:info-circle-bold';
      var body = '';

      if (a.type === 'contact') {
        if (a.phone) body += '<a class="awofind__answer-row" href="' + attr(telHref(a.phone)) + '"><iconify-icon icon="solar:phone-bold" inline></iconify-icon>' + esc(a.phone) + '</a>';
        if (a.email) body += '<a class="awofind__answer-row" href="mailto:' + attr(a.email) + '"><iconify-icon icon="solar:letter-bold" inline></iconify-icon>' + esc(a.email) + '</a>';
        body += hoursHtml(a.hours);
      } else if (a.type === 'hours') {
        body += hoursHtml(a.hours);
      } else if (a.type === 'showroom') {
        var locs = (a.locations || []).concat(a.others || []);
        body += locs.map(function (l) {
          var addr = [l.address, l.postcode].filter(Boolean).join(', ');
          var actions = '';
          if (l.phone) actions += '<a href="' + attr(telHref(l.phone)) + '">Call</a>';
          if (l.mapUrl) actions += '<a href="' + attr(l.mapUrl) + '" target="_blank" rel="noopener">Directions</a>';
          if (l.url) actions += '<a href="' + attr(l.url) + '">Details</a>';
          return '<div class="awofind__shop">' +
            '<div class="awofind__shop-name">' + esc(l.name) + '</div>' +
            (addr ? '<div class="awofind__shop-addr">' + esc(addr) + '</div>' : '') +
            (actions ? '<div class="awofind__shop-actions">' + actions + '</div>' : '') +
          '</div>';
        }).join('');
      } else if (a.summary) {
        body += '<p class="awofind__answer-summary">' + esc(a.summary) + '</p>';
      }

      var link = a.url ? '<a class="awofind__answer-link" href="' + attr(a.url) + '">' + esc(a.title) + ' &rarr;</a>' : '';

      return '<div class="awofind__sec"><div class="awofind__answer">' +
        '<div class="awofind__answer-head"><span class="awofind__answer-ic"><iconify-icon icon="' + icon + '" inline></iconify-icon></span>' +
        '<span class="awofind__answer-title">' + esc(a.title) + '</span></div>' +
        (body ? '<div class="awofind__answer-body">' + body + '</div>' : '') +
        link +
      '</div></div>';
    }
    function pagesBlock(pages) {
      if (!pages || !pages.length) return '';
      var html = '<div class="awofind__sec"><div class="awofind__sec-label">Pages</div>';
      pages.slice(0, 4).forEach(function (p) {
        html += '<a class="awofind__page" href="' + attr(p.url) + '">' +
          '<span class="awofind__page-ic"><iconify-icon icon="solar:document-text-linear" inline></iconify-icon></span>' +
          '<span class="awofind__page-tx"><span class="awofind__page-title">' + esc(p.title) + '</span>' +
          (p.snippet ? '<span class="awofind__page-snip">' + esc(p.snippet) + '</span>' : '') +
          '</span></a>';
      });
      return html + '</div>';
    }

    function searchRow(q, label, sub, cls, icon, trail) {
      return '<div class="awofind__row ' + (cls || '') + '" data-awofind-go="' + attr(q) + '">' +
        icon +
        (sub
          ? '<span class="awofind__col"><div class="awofind__tx">' + label + '</div><div class="awofind__sub">' + esc(sub) + '</div></span>'
          : '<span class="awofind__tx">' + label + '</span>') +
        (trail || '') + '</div>';
    }

    // ----- completion + match placeholders (API: replace with fetchSuggest) ----
    function complete(v) {
      var lq = v.toLowerCase();
      var first = lq.split(' ')[0];
      return DATA.completions.filter(function (d) {
        var dl = d.toLowerCase();
        return dl !== lq && (dl.indexOf(lq) > -1 ||
          (first.length > 2 && dl.indexOf(first.slice(0, Math.max(3, first.length - 1))) > -1));
      }).slice(0, 3);
    }
    function matchProducts(v) {
      var tokens = v.toLowerCase().split(' ').filter(function (t) { return t.length > 2; });
      return DATA.popular.filter(function (p) {
        var hay = (p.tags || '');
        return tokens.some(function (t) { return hay.indexOf(t.slice(0, Math.max(3, t.length - 1))) > -1; });
      }).slice(0, 4);
    }

    // Normalise a backend product into the shape card() expects.
    function moneyFmt(val) {
      if (val == null || val === '') return '';
      if (typeof val === 'string') return val;          // already formatted (e.g. "£449")
      try {
        return new Intl.NumberFormat('en-GB', { style: 'currency', currency: 'GBP' }).format(val / 100);
      } catch (e) { return '£' + (val / 100).toFixed(2); } // assume integer pence
    }
    function normProduct(p) {
      var compare = p.compare != null ? p.compare : p.compare_at;
      return {
        id: p.id != null ? p.id : (p.product_id != null ? p.product_id : null),
        handle: p.handle,
        url: p.url || (p.handle ? '/products/' + p.handle : null),
        brand: p.brand || p.vendor || '',
        title: p.title || '',
        price: moneyFmt(p.price != null ? p.price : p.price_min),
        compare: compare != null ? moneyFmt(compare) : null,
        image: p.image || p.featured_image || null,
        energy: p.energy || null,
        frostFree: !!p.frost_free,
        inStock: p.in_stock !== false,
        discount: p.discount || null,
        kind: p.kind || 'fridge'
      };
    }

    // Live suggest endpoint. Falls back to offline block data if no API is set
    // or the request fails (e.g. ngrok tunnel down).
    function fetchSuggest(v) {
      if (!API) {
        return Promise.resolve({ completions: complete(v), products: matchProducts(v), nav: null });
      }
      return fetch(API + '/suggest?q=' + encodeURIComponent(v), {
        headers: { 'ngrok-skip-browser-warning': 'true' }
      })
        .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.json(); })
        .then(function (d) {
          return {
            interpreted: d.interpreted || '',
            completions: (d.completions || []).map(String),
            products: (d.products || []).map(normProduct),
            answer: d.answer || null,
            pages: d.pages || [],
            nav: d.nav || null              // { q, sort, filters } → native filtered search URL
          };
        })
        .catch(function (e) {
          console.warn('[awofind] suggest request failed — using offline fallback:', e && e.message ? e.message : e);
          return { completions: complete(v), products: matchProducts(v), answer: null, pages: [], nav: null };
        });
    }

    // Turn the backend's nav object ({ q, sort, filters }) into a native Shopify
    // search URL. filters values may be a string or an array (repeated param).
    // Falls back to a plain ?q= search when nav is absent.
    function navToUrl(nav, rawQ) {
      var q = (nav && nav.q != null && String(nav.q).trim() !== '') ? nav.q : rawQ;
      var parts = [
        'q=' + encodeURIComponent(q),
        'type=product',
        'options%5Bprefix%5D=last'
      ];
      if (nav && nav.sort) parts.push('sort_by=' + encodeURIComponent(nav.sort));
      if (nav && nav.filters) {
        Object.keys(nav.filters).forEach(function (key) {
          var val = nav.filters[key];
          (Array.isArray(val) ? val : [val]).forEach(function (v) {
            if (v == null || v === '') return;
            parts.push(encodeURIComponent(key) + '=' + encodeURIComponent(v));
          });
        });
      }
      return DATA.searchAction + '?' + parts.join('&');
    }

    // Fetch a nav interpretation for an arbitrary query (used when the user
    // submits something we haven't a fresh suggest nav for). Resolves to null
    // on any failure so go() degrades to a plain search.
    function fetchNav(q) {
      if (!API) return Promise.resolve(null);
      return fetch(API + '/results?q=' + encodeURIComponent(q) + '&page_size=1', {
        headers: { 'ngrok-skip-browser-warning': 'true' }
      })
        .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.json(); })
        .then(function (d) { return d.nav || null; })
        .catch(function () { return null; });
    }

    // ----- render --------------------------------------------------------
    function renderEmpty() {
      var html = OFFERS_HTML;
      var recent = getRecent();
      if (recent.length) {
        html += '<div class="awofind__sec"><div class="awofind__sec-label">Recent</div>';
        recent.forEach(function (r) {
          html += searchRow(r, esc(r), null, '', IC.clock, TR_UPLEFT);
        });
        html += '</div>';
      }
      if (DATA.popular.length) {
        html += '<div class="awofind__sec"><div class="awofind__sec-label">Popular right now</div>' +
          cardGrid(DATA.popular.slice(0, 6)) +
          '</div>';
      }
      if (DATA.ask.length) {
        html += '<div class="awofind__sec"><div class="awofind__sec-label"><span class="awofind__sk">' + SPARK + '</span> Ask anything</div>';
        DATA.ask.forEach(function (a) {
          html += searchRow(a.query, '<b>' + esc(a.question) + '</b>', a.sub, 'is-ai', IC.spark, TR_ARROW);
        });
        html += '</div>';
      }
      panel.innerHTML = html;
      reflect();
    }

    var renderToken = 0;
    var suggestTimer;
    var latestNav = null;   // { q: <typed query>, nav: <nav object> } from the most recent suggest

    function render(v) {
      v = (v || '').trim();
      currentQuery = v;
      if (!v) { clearTimeout(suggestTimer); renderEmpty(); return; }

      // Show a shimmer skeleton instantly while suggestions load. Keep an existing
      // skeleton in place across keystrokes so it shimmers smoothly (no re-flicker).
      if (API) {
        if (!panel.querySelector('[data-skeleton]')) {
          panel.innerHTML = skeletonSection(3);
          reflect();
        }
      } else {
        panel.innerHTML = '';
        reflect();
      }

      var token = ++renderToken;
      clearTimeout(suggestTimer);
      suggestTimer = setTimeout(function () {
        Promise.resolve(fetchSuggest(v)).then(function (s) {
          if (token !== renderToken) return;            // a newer keystroke superseded this
          latestNav = { q: v, nav: s.nav || null };     // remember for an instant, correct go()
          var html = '';

          if (s.completions && s.completions.length) {
            html += '<div class="awofind__sec">';
            s.completions.slice(0, 3).forEach(function (t) {
              var i = t.toLowerCase().indexOf(v.toLowerCase());
              var label = i === 0
                ? '<b>' + esc(t.slice(0, v.length)) + '</b><em>' + esc(t.slice(v.length)) + '</em>'
                : '<em>' + esc(t) + '</em>';
              html += searchRow(t, label, null, '', IC.glass, TR_UPLEFT);
            });
            html += '</div>';
          }

          if (s.products && s.products.length) {
            html += '<div class="awofind__sec"><div class="awofind__sec-label">Products</div>' +
              cardGrid(s.products.slice(0, 6)) +
              '</div>';
          }

          // instant answers + page links (lower priority than products)
          html += answerBlock(s.answer);
          html += pagesBlock(s.pages);

          var nothingExtra = !(s.completions && s.completions.length) && !(s.products && s.products.length) &&
            !s.answer && !(s.pages && s.pages.length);
          if (nothingExtra) {
            html += '<div class="awofind__sec"><div class="awofind__row" style="cursor:default;">' +
              '<span class="awofind__tx" style="color:var(--awofind-grey);">No quick matches — press Enter to search everything.</span></div></div>';
          }

          panel.innerHTML = html;
          reflect();
        });
      }, 180);
    }

    // ----- behaviour -----------------------------------------------------
    // Only flatten the field / show the panel when there is content to show,
    // so an empty result keeps the field fully rounded (no "cut-off" look).
    function reflect() {
      var hasContent = panel.innerHTML.trim().length > 0;
      field.classList.toggle('is-open', hasContent);
      if (scrim) scrim.classList.toggle('is-shown', hasContent);
    }
    function open() { render(input.value); }
    function close() { field.classList.remove('is-open'); if (scrim) scrim.classList.remove('is-shown'); }
    function sync() {
      var has = input.value.length > 0;
      field.classList.toggle('has-text', has);
      clearB.classList.toggle('is-shown', has);
      sendB.disabled = !has;
    }
    // Submit → native search results template (decorated with AI chips), landing
    // pre-filtered/-sorted via the backend's nav interpretation when available.
    function go(q) {
      q = (q || '').trim();
      if (!q) return;
      pushRecent(q);

      // Fast path: the latest suggest already interpreted this exact query.
      if (latestNav && latestNav.q === q) {
        window.location.href = navToUrl(latestNav.nav, q);
        return;
      }
      // Otherwise fetch a fresh interpretation (recent/completion/ask rows, or an
      // Enter before suggest resolved), then navigate. Degrades to plain ?q=.
      if (API) {
        fetchNav(q).then(function (nav) { window.location.href = navToUrl(nav, q); });
        return;
      }
      window.location.href = navToUrl(null, q);
    }

    input.addEventListener('focus', open);
    input.addEventListener('input', function () {
      sync();
      render(input.value);
    });
    input.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' && input.value.trim()) go(input.value);
      if (e.key === 'Escape') close();
    });
    clearB.addEventListener('click', function () { input.value = ''; sync(); input.focus(); render(''); });
    sendB.addEventListener('click', function () { go(input.value); });
    if (scrim) scrim.addEventListener('click', close);
    if (focusB) focusB.addEventListener('click', function () { input.focus(); });

    // delegate clicks for product cards (analytics) + search rows (rebuilt on every render)
    panel.addEventListener('click', function (e) {
      var pcard = e.target.closest('[data-awofind-pcard]');
      if (pcard) {
        var posAttr = pcard.getAttribute('data-pos');
        sendClick({
          q: currentQuery,
          id: pcard.getAttribute('data-id') || null,
          handle: pcard.getAttribute('data-handle') || null,
          position: posAttr === '' ? null : parseInt(posAttr, 10),
          mode: 'suggest'
        });
        return; // let the native link navigate
      }
      var row = e.target.closest('[data-awofind-go]');
      if (row) { e.preventDefault(); go(row.getAttribute('data-awofind-go')); }
    });

    // optional voice search
    if (micB) {
      var SR = window.SpeechRecognition || window.webkitSpeechRecognition;
      if (SR) {
        micB.hidden = false;
        micB.addEventListener('click', function () {
          var rec = new SR();
          rec.lang = 'en-GB';
          rec.interimResults = false;
          rec.onresult = function (ev) {
            input.value = ev.results[0][0].transcript;
            sync(); open(); render(input.value);
          };
          rec.start();
        });
      }
    }

    // ----- rotating promo bar --------------------------------------------
    // Date-gating is done server-side (only in-window promos are rendered).
    // Here we just auto-advance between them with a synced progress bar that
    // pauses on hover/tab-blur. A single promo stays static (no timer/bar).
    function initPromos() {
      var wrap = root.querySelector('[data-awofind-promos]');
      if (!wrap) return;
      var slides = Array.prototype.slice.call(wrap.querySelectorAll('[data-promo-slide]'));
      if (!slides.length) return;

      if (slides.length === 1) { slides[0].classList.add('is-active'); return; }

      var DUR = parseInt(wrap.getAttribute('data-promo-interval'), 10) || 6000;
      wrap.style.setProperty('--promo-dur', (DUR / 1000) + 's');

      var i = 0, timer = null, startedAt = 0, remaining = DUR;

      function barOf(n) { return slides[n] && slides[n].querySelector('[data-promo-bar]'); }
      function restartBar() {
        var b = barOf(i);
        if (!b) return;
        b.style.animationPlayState = 'running';
        b.classList.remove('is-running');
        void b.offsetWidth;                   // force reflow so the animation replays
        b.classList.add('is-running');
      }
      function show(n) {
        i = n;
        slides.forEach(function (s, k) { s.classList.toggle('is-active', k === n); });
        restartBar();
      }
      function schedule(ms) { stop(); startedAt = Date.now(); remaining = ms; timer = setTimeout(advance, ms); }
      function advance() { show((i + 1) % slides.length); schedule(DUR); }
      function stop() { if (timer) { clearTimeout(timer); timer = null; } }
      function pause() {
        if (!timer) return;
        stop();
        remaining -= (Date.now() - startedAt);
        var b = barOf(i); if (b) b.style.animationPlayState = 'paused';
      }
      function resume() {
        if (timer) return;
        var b = barOf(i); if (b) b.style.animationPlayState = 'running';
        schedule(Math.max(400, remaining));
      }

      show(0); schedule(DUR);
      wrap.addEventListener('mouseenter', pause);
      wrap.addEventListener('mouseleave', resume);
      document.addEventListener('visibilitychange', function () {
        if (document.hidden) pause(); else resume();
      });
    }
    initPromos();

    sync();
  }

  function boot() {
    document.querySelectorAll('[data-awofind]').forEach(init);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', boot);
})();
